// extracted by mini-css-extract-plugin
export var changeLogs = "index-module--changeLogs--gkyef";
export var container = "index-module--container--Rkd3T";
export var copySha = "index-module--copySha--WJAln";
export var downArrow = "index-module--downArrow--3lO9z";
export var extraNote = "index-module--extraNote--pVnAz";
export var gradBorder = "index-module--gradBorder--hCV6j";
export var hash = "index-module--hash--87Eo2";
export var hashContainer = "index-module--hashContainer--JpqDD";
export var leftSide = "index-module--leftSide--T9qti";
export var log = "index-module--log--SJCP1";
export var logDate = "index-module--logDate--Higkw";
export var logHeader = "index-module--logHeader--T8OxM";
export var rightSide = "index-module--rightSide--OtKuC";
export var sha = "index-module--sha--TIHcd";
export var specialH4 = "index-module--specialH4--o+USf";
export var updateList = "index-module--updateList--vcIsG";
export var updates = "index-module--updates--AslHK";